export default "__VITE_ASSET__CnY_uws2__"